import React from 'react'

import { DefaultTopbar } from '../../core/components/TopbarVariations'

export const CartCaptureScreen = () => {
  return <DefaultTopbar />
}
